<div class="ui basic segment" [class.loading]="isLoading">
    <app-header
        [back]="true"
        title="{{ 'time-off-v3.assignToTimeOffPolicynamePolicy' | translate: { name: timeOffPolicy?.name } }}"
    ></app-header>
    <app-steps
        #appSteps
        [labels]="{ primary: 'time-off-v3.save' }"
        action="click"
        [steps]="[employeeSelect, additionsStep, removalsStep]"
        [beforeNext]="shouldMoveToNextStep"
        (onPrimary)="onSave()"
        (onNext)="onNextStep($event)"
    >
        <app-step
            #employeeSelect
            [stepForm]="employeeSelectForm"
            step="{{ 'time-off-v3.selectEmployee' | translate }}"
            title="{{ 'time-off-v3.selectEmployees' | translate }}"
        >
            <app-employee-select-form
                [additions]="additions"
                [removals]="removals"
                [assignedEmployees]="assignedEmployees"
                [timeOffPolicy]="timeOffPolicy"
                (changedSelections)="updateAdditionsAndRemovals($event)"
                #employeeSelectForm
            ></app-employee-select-form>
        </app-step>

        <app-step
            #additionsStep
            [stepForm]="employeeAdditionForm"
            step="{{ 'time-off-v3.additions' | translate }}"
            title="{{ 'time-off-v3.additionsEffectiveDate' | translate }}"
        >
            <app-employee-addition-form
                [additions]="additions"
                [timeOffPolicy]="timeOffPolicy"
                #employeeAdditionForm
            ></app-employee-addition-form>
        </app-step>

        <app-step
            #removalsStep
            [stepForm]="employeeRemovalForm"
            stepKey="Removals"
            step="{{ 'time-off-v3.removals' | translate }}"
            title="{{ 'time-off-v3.removalsEffectiveDate' | translate }}"
        >
            <app-employee-removal-form [removals]="removals" #employeeRemovalForm></app-employee-removal-form>
        </app-step>
    </app-steps>
</div>
